module.exports = __webpack_public_path__ + "img/f1-2-4.a83d2f52.png";